<template>
  <materials-base-container
    :active-category.sync="category"
    :search.sync="search"
    :search-tag.sync="searchTag"
    :mandatory-category.sync="mandatoryCategory"
  >
    <template #default>
      <router-view
        name="contentCentral"
        class="flex-grow-1"
        :active-category.sync="category"
        :search.sync="search"
        :search-tag.sync="searchTag"
        :mandatory-category.sync="mandatoryCategory"
      >
      </router-view>
    </template>
  </materials-base-container>
</template>

<script>
  import MaterialsBaseContainer from '@/components/Materials/MaterialsBaseContainer';

  export default {
    name: 'CategoriesContainerView',

    components: {
      MaterialsBaseContainer,
    },

    data() {
      return {
        category: undefined,
        search: undefined,
        searchTag: undefined,
        mandatoryCategory: true,
      }
    },

    watch: {
      searchTag: {
        handler(v, old) {
          if (v === old) return;
          this.search = undefined;
          this.category = undefined;
        },
      },
    }
  }
</script>
